import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _Number$isNaN from '@babel/runtime-corejs3/core-js-stable/number/is-nan';
import React__default, { useState, useCallback, useMemo } from 'react';
import classNames from 'classnames';
import styles from './8bb9413bdd14fb51d5d29cbdf0609528177aa9a6e776e76866c59fac1d57e03b.cfe-internal.js';
import NumberStepperIncrement from './e053aed4aa6b0a460ba939a8391ec9b39c8e1fbb22dc99202202035fc04595b0.cfe-internal.js';
import NumberStepperDecrement from './44ba69f320e3318009b20fd1563a94ba808efb164753639fab293d52ccacbf4e.cfe-internal.js';
import NumberStepperInput from './880235e70239db08fd2c239bfb406b34a8bd245963f87bacfa38b28aa407a3d4.cfe-internal.js';
import { NumberStepperContextProvider } from './cab259ea986bae84b53c604411632728b26d185d6bd5f24fb5bdb7d35490dde4.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useControllableState from '../../hooks/useControllableState/fc7c2512fc1249f4837f2cb1f271d18191fa6aebd32c5f03023614c2b76711ef.cfe-internal.js';

var _excluded = ["isDisabled", "data-testid", "inputId", "defaultValue", "value", "step", "min", "max", "width", "className", "aria-label", "aria-labelledby", "aria-describedby", "style", "children", "onChange"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Renders the NumberStepper component.
 * This component is offered as a "default" (aka simple) component or an "advanced" (aka composite) component.
 */
var NumberStepper = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var isExternallyDisabled = _ref.isDisabled,
    dataTestId = _ref['data-testid'],
    inputId = _ref.inputId,
    _ref$defaultValue = _ref.defaultValue,
    defaultValue = _ref$defaultValue === void 0 ? 0 : _ref$defaultValue,
    externalValue = _ref.value,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    min = _ref.min,
    max = _ref.max,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 127 : _ref$width,
    className = _ref.className,
    ariaLabel = _ref['aria-label'],
    ariaLabelledBy = _ref['aria-labelledby'],
    ariaDescribedBy = _ref['aria-describedby'],
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    children = _ref.children,
    onChange = _ref.onChange,
    rest = _objectWithoutProperties(_ref, _excluded);
  /*
   * Input value that comes from:
   * (1) The `externalValue` prop, or
   * (2) Internal state (if `externalValue` is undefined).
   */
  var _useControllableState = useControllableState(defaultValue, onChange, externalValue),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    inputValue = _useControllableState2[0],
    setInputValue = _useControllableState2[1];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    wasIncrementOrDecrementButtonPressed = _useState2[0],
    setWasIncrementOrDecrementButtonPressed = _useState2[1];

  /**
   * Increments the `inputValue` by `step`.
   * The new value is bounded by `max` if `max` is defined.
   */
  var increment = useCallback(function (isTriggeredByIncrementButton) {
    setInputValue(function (currentValue) {
      var newValue = convertToNumber(currentValue) + step;

      // Value needs to be rounded for accuracy
      var newValueRounded = Math.round(newValue * 100) / 100;
      return clampMinMax(newValueRounded, {
        max: max
      });
    });
    setWasIncrementOrDecrementButtonPressed(isTriggeredByIncrementButton);
  }, [step, max, setInputValue]);

  /**
   * Decrements the `inputValue` by `step`.
   * The new value is bounded by `min` if `min` is defined.
   */
  var decrement = useCallback(function (isTriggeredByDecrementButton) {
    setInputValue(function (currentValue) {
      var newValue = convertToNumber(currentValue) - step;

      // Value needs to be rounded for accuracy
      var newValueRounded = Math.round(newValue * 100) / 100;
      return clampMinMax(newValueRounded, {
        min: min
      });
    });
    setWasIncrementOrDecrementButtonPressed(isTriggeredByDecrementButton);
  }, [step, min, setInputValue]);

  /**
   * Updates the `inputValue` to `max`
   */
  var increaseToMax = useCallback(function () {
    if (max !== undefined) {
      setInputValue(max);
    }
  }, [max, setInputValue]);

  /**
   * Updates the `inputValue` to `min`
   */
  var decreaseToMin = useCallback(function () {
    if (min !== undefined) {
      setInputValue(min);
    }
  }, [min, setInputValue]);

  /**
   * Updates the `inputValue` to be:
   * (1) An empty string, or
   * (2) The entered value as a number
   */
  var handleInputChange = useCallback(function (e) {
    var val = e.target.value;
    if (val === '') {
      setInputValue(val);
    } else {
      // Value needs to be rounded for accuracy
      var newValueRounded = Math.round(Number(val) * 100) / 100;
      setInputValue(newValueRounded);
    }
  }, [setInputValue]);

  /**
   * Updates the `inputValue` to be:
   * (1) The entered value as a number, or
   * (2) The `min` or `max` value
   */
  var handleInputBlur = useCallback(function () {
    setInputValue(function (currentValue) {
      return clampMinMax(convertToNumber(currentValue), {
        min: min,
        max: max
      });
    });
  }, [max, min, setInputValue]);

  // NumberStepper context
  var context = useMemo(function () {
    return {
      isExternallyDisabled: isExternallyDisabled,
      dataTestId: dataTestId,
      inputId: inputId,
      inputValue: inputValue,
      step: step,
      min: min,
      max: max,
      ariaLabel: ariaLabel,
      ariaLabelledBy: ariaLabelledBy,
      ariaDescribedBy: ariaDescribedBy,
      increment: increment,
      decrement: decrement,
      increaseToMax: increaseToMax,
      decreaseToMin: decreaseToMin,
      handleInputChange: handleInputChange,
      handleInputBlur: handleInputBlur
    };
  }, [isExternallyDisabled, dataTestId, inputId, inputValue, step, min, max, ariaLabel, ariaLabelledBy, ariaDescribedBy, increment, decrement, increaseToMax, decreaseToMin, handleInputChange, handleInputBlur]);
  return /*#__PURE__*/React__default.createElement("span", _extends({}, rest, {
    "data-testid": dataTestId,
    ref: ref,
    className: classNames(styles.numberStepperContainer, className),
    style: _objectSpread({
      width: width
    }, style)
  }), /*#__PURE__*/React__default.createElement(NumberStepperContextProvider, {
    value: context
  }, children || /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(NumberStepperDecrement, null), /*#__PURE__*/React__default.createElement(NumberStepperInput, null), /*#__PURE__*/React__default.createElement(NumberStepperIncrement, null))), wasIncrementOrDecrementButtonPressed && /*#__PURE__*/React__default.createElement("span", {
    role: "alert",
    className: styles.inputValueAlert
  }, inputValue));
});

/**
 * Attempts to convert the given `value` to a number
 */
function convertToNumber(value) {
  if (typeof value === 'number') {
    return value;
  }
  var num = Number(value);
  if (_Number$isNaN(num)) {
    return 0;
  }
  return num;
}

/**
 * Compares the given `value` to min and/or max
 */
function clampMinMax(value, _ref2) {
  var min = _ref2.min,
    max = _ref2.max;
  if (typeof max === 'number' && value > max) {
    return max;
  }
  if (typeof min === 'number' && value < min) {
    return min;
  }
  return value;
}

export { NumberStepper, NumberStepper as default };
